import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import requestUtil from "../../../../helpers/requestUtil";
import useConfiguration from "../../../../hooks/useConfiguration";
import useSessionStorage from "../../../../hooks/useSessionStorage";
import {
  setLoadingPageFalse,
  setLoadingPageTrue,
} from "../../../common/Loader/action";
import { setLoading } from "../../../common/Loader/slice";
import * as Toasts from "../../../common/Toastify";
import {
  getCallHistory,
  getCommentEmailSMSPhoneHistory,
  getEmployerComments,
  updateQAData,
} from "./action";
import { candidateSearchViewSelector } from "./selector";
import moment from "moment";
import EmailReply from "../../../common/Modal/emailReply";
import ToolTip from "../../../common/ToolTip/ToolTip";
import { getSMSDetails, sendAllSmsbtn, sendSMS } from "./action";
import { toast } from "react-toastify";
import SMSModal from "../../../common/Modal/SMSModal";
import { ImAttachment } from "react-icons/im";
// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const { CommentSummry_candidateUniqueId, data, userData } = props;
  console.log({ userData });
  const { EmployerComments } = useSelector(candidateSearchViewSelector);
  const [callHistoryIndex, setcallHistoryIndex] = useState("");
  const [callHistoryFlag, setcallHistoryIndexFlag] = useState(false);
  const emailHistory = useSelector(
    (store) => store.candidateSearchViewInfo.commentHistory?.emailHistory
  );
  const textHistory = useSelector(
    (store) => store.candidateSearchViewInfo.commentHistory?.textHistory
  );
  const phoneHistory = useSelector(
    (store) => store.candidateSearchViewInfo.commentHistory?.phoneHistory
  );
  const config = useConfiguration();
  const baseUrl = config.baseUrl;
  const dispatch = useDispatch();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const [Message, setMessage] = useState("");
  const [Comment, setComment] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState("");
  const [showHistoryList, setShowHistoryList] = useState({
    emailHistory: false,
    textHistory: false,
    phoneHistory: false,
  });
  const [replyModal, setReplyModal] = useState({ flag: false, id: "", data: {} });
  const [callHistoryToggle, setCallHistoryToggle] = useState(false);
  const [mainHistoryToggle, setMainHistoryToggle] = useState(false);
  const [showSmsToggle, setShowSmsToggle] = useState(false)
  const [childHistoryToggle, setChildHistoryToggle] = useState('');
  const [candidateName, setCandidateName] = useState('');
  const [smsModalList, setSmsModalList] = useState([]);
  const [smsModalInd, setSmsModalInd] = useState(false);
  const [smsModalData, setSmsModalData] = useState({});
  const [smsModalGetData, setSmsModalGetData] = useState({ sms: "" });
  //console.log("First Candidate ID ",EmployerComments)
  useEffect(() => {
    console.log("First Candidate ID 1", CommentSummry_candidateUniqueId);
    if (config.baseUrl) {
      console.log("First Candidate ID 2", CommentSummry_candidateUniqueId);
      if (CommentSummry_candidateUniqueId && CommentSummry_candidateUniqueId) {
        dispatch(
          getEmployerComments({
            url: `${config.baseUrl}/Employers/get-employers-comment`,
            candidateUniqueId: CommentSummry_candidateUniqueId,
            employerUniqueId: login.employerUniqueId,
          })
        );
      }
    }
  }, [config]);

  const handleChange = (target, tabId, sectionId, id) => {
    const { value } = target;
    setComment(value);
  };

  const saveSummaryComment = () => {
    if (Comment !== "") {
      dispatch(setLoading(true));
      requestUtil(
        `${config.baseUrl}/Employers/save-employers-comment`,
        "POST",
        {
          candidateUniqueId: CommentSummry_candidateUniqueId,
          employerUniqueId: login.employerUniqueId,
          appUserUniqueId: login.appUserUniqueId,
          comment: Comment,
        }
      )
        .then((response) => {
          Toasts.success(response.message);
          setMessage(response.message);
          setComment("");
          setError("");
          if (
            CommentSummry_candidateUniqueId &&
            CommentSummry_candidateUniqueId
          ) {
            dispatch(
              getEmployerComments({
                url: `${config.baseUrl}/Employers/get-employers-comment`,
                candidateUniqueId: CommentSummry_candidateUniqueId,
                employerUniqueId: login.employerUniqueId,
              })
            );
          }
          dispatch(setLoading(false));
        })
        .catch((error) => {
          setErrorMessage(error.message || "Failed to add comment summary");
          Toasts.error("Failed to add comment summary");
          dispatch(setLoading(false));
        });
    } else {
      console.log("Error");
      setError("Please add comments");
    }
  };
  const getCommentHistory = ({ url, name, params, method }) => {
    setShowHistoryList((prev) => ({ ...prev, [name]: !showHistoryList[name] }));
    if (!showHistoryList?.[name]) {
      dispatch(getCommentEmailSMSPhoneHistory({ name, url, params, method }));
    }
  };
  const getCallHistoryList = ({ phone, name }) => {
    const params = {
      phoneNumber: `${phone.replace(/-/g, "")}`,
    };
    setShowHistoryList((prev) => ({ ...prev, [name]: !showHistoryList[name] }));
    if (!showHistoryList?.[name]) {
      dispatch(getCallHistory(config.baseUrl, params));
    }
  };
  const regex = /(<([^>]+)>)/gi;

  const openReplyModal = (id, val) => {
    if (id && val) {
      setReplyModal({ flag: true, id: id, data: val });
    }
  };

  const closeReplyModal = () => {
    setReplyModal({ flag: false, id: "", data: {} });
  };

  const downloadUploadDoc = async (filename, docId, { url }) => {
    const requestHeaders = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: login.accessToken ? `Bearer ${login.accessToken}` : "",
    };
    fetch(`${config.baseUrl}/${url}${JSON.stringify(docId)}`, {
      headers: requestHeaders,
    }).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
      });
    });
  };

  // Show SMS Modal Box
  const showSmsModal = async (data) => {
    setCandidateName(userData?.name);
    if (smsModalInd) {
      setSmsModalList([]);
    } else {
      if (!!login?.verifiedPhoneNumber) {
        const params = {
          candidateUniqueId: data?.candidateUniqueId,
          employerMobileNumber: login.verifiedPhoneNumber,
          candidateMobileNumber: `${login.countryPhoneCode}${(userData?.phone)?.replace(/-/g, '')}`
        }
        const smsDetailsResult = await dispatch(
          getSMSDetails({
            url: `${config.baseUrl}/Messaging/get-sms-messages`, params
          }),
        );
        setSmsModalList(smsDetailsResult);
      } else {
        toast.error("SMS faciality not mapped to this employer.")
        return
      }
    }
    getSmsModalData("sms", "");
    setSmsModalData(data);
    setSmsModalInd((preVal) => !preVal);
  };

  // get Modal data
  const getSmsModalData = (index, value) => {
    setSmsModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // Send All for SMS
  const sendAllSms = () => {
    dispatch(
      sendAllSmsbtn('https://development.overturexl.com/DevMessagingApi/api/Messaging/sendSMS')
    );
    showSmsModal();
  };

  // Save Single SMS Modal box
  const saveSmsModal = async () => {
    const requestBody = {
      candidateUniqueId: smsModalData.candidateUniqueId,
      messageBody: smsModalGetData.sms,
      ParentId: smsModalData?.messageTrackingId
    };
    dispatch(
      sendSMS({
        url: `${config.baseUrl}/Messaging/send-sms-to-candidate`,
        params: requestBody,
      }),
    ).then(() => {
      const params = {
        candidateUniqueId: userData?.candidateUniqueId,
        employerMobileNumber: login.verifiedPhoneNumber,
        candidateMobileNumber: `${login.countryPhoneCode}${(userData?.phone).replace(/-/g, '')}`,
        isRecentMessageOnTop: true
      }
      const url = `${config.baseUrl}/Messaging/get-sms-messages`
      dispatch(getCommentEmailSMSPhoneHistory({ name: 'textHistory', url, params }));
      showSmsModal();
    });

  };
  console.log(userData, '---------------->');
  return (
    <>
      <EmailReply
        showModal={replyModal.flag}
        closeModal={closeReplyModal}
        candidateUniqueId={replyModal.id}
        data={replyModal.data}

      />
      <SMSModal
        showModal={smsModalInd}
        handleClose={showSmsModal}
        data={smsModalData}
        handleSave={saveSmsModal}
        formData={smsModalGetData}
        handleForm={getSmsModalData}
        listData={smsModalList}
        sendAllSms={sendAllSms}
        groupSMSSaveFlag={false}
        candidateName={candidateName}
      />
      <div className="col-md-12 col-xl-12">
        <div className="PrintHeader">
          <h4 className="mb-0">Add Comments</h4>
        </div>

        {/* <div class="col-md-12 col-xl-12"> */}
        {/* <div class="card card-collapsed"> */}
        {/*<div class="card-header">
                          <h3 class="card-title">Comment Summary</h3>
                       <div class="card-options">
                            <a href="javascript:void(0)" class="card-options-collapse" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a>
                        </div> 
                    </div>*/}
        <div class="card-body">
          <form class="profile-edit">
            <textarea
              class="form-control"
              rows="7"
              name="textValue"
              value={Comment}
              onChange={(e) => handleChange(e.target)}
            ></textarea>
            <div class="profile-share border-top-0">
              <button
                className="btn btn-primary sw-btn-next btnsmlbox"
                type="button"
                onClick={() => {
                  saveSummaryComment();
                }}
              >
                {" "}
                Add comment
              </button>
            </div>
            <div className="invalid-input">{error}</div>
          </form>
        </div>

        {/* </div> */}
      </div>
      <div class="col-md-12 col-xl-12">
        {/* <div class="card card-collapsed"> */}
        <div>
          <h4 class="mb-0">Comments History</h4>
          {/* <div class="card-options">
                            <a href="javascript:void(0)" class="card-options-collapse" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a>
                        </div> */}

          <div class="card-body">
            {EmployerComments?.employersComments?.map((item) => {
              return (
                <>
                  <div
                    class="media-body ms-3 d-flex"
                    style={{ margin: "20px 0px 10px 10px" }}
                  >
                    <div class="">
                      <p class="fs-15 text-dark fw-bold mb-0">
                        {item.commentByName}
                      </p>
                      <p class="mb-0 fs-13 text-dark">{item.comment}</p>
                    </div>
                    <div class="notify-time">
                      <p class="mb-0 text-muted fs-11">
                        {item.commentDateToDisplay}
                      </p>
                    </div>
                  </div>
                  <hr className="Line"></hr>
                </>
              );
            })}
          </div>
        </div>
      </div>

      <div class="accordion" id="accordionExample">
        {/* PhoneHistory */}
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class={`accordion-button collapsed ${callHistoryToggle ? 'rotate-communication':''}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
              onClick={() => {
                getCallHistoryList({
                  phone: `${login.countryPhoneCode}${data?.cellPhoneNumber}`,
                  name: "emailHistory",
                  method: 'POST'
                })
                setCallHistoryToggle(!callHistoryToggle)
              }
              }
            >
              Call History
            </button>
          </h2>
          {callHistoryToggle &&
            <div
            // id="collapseOne"
            // class="accordion-collapse collapse"
            // aria-labelledby="headingOne"
            // data-bs-parent="#accordionExample"
            >
              <div class="accordion-body">
                <div class="table-responsive">
                  <table class="table table-inbox table-hover text-nowrap mb-0">
                    <tbody>
                      {phoneHistory?.length > 0 &&
                        phoneHistory?.map((element, index) => {
                          return (
                            <>
                              <tr
                                class="collapsed"
                                data-bs-toggle="collapse"
                                data-bs-parent="#accordion"
                                href={`#data_${index}`}
                                aria-expanded="false"
                                aria-controls={`data_${index}`}
                              >
                                <td>{element.callDateToDisplay}</td>
                                <td className={`text-end`}>
                                  <audio
                                    controls
                                    style={{ height: "30px" }}
                                    className={`btn ${callHistoryFlag === true &&
                                      callHistoryIndex !== index
                                      ? "disableAudio"
                                      : ""
                                      }`}
                                    onPlay={() => {
                                      setcallHistoryIndexFlag(true);
                                      setcallHistoryIndex(index);
                                    }}
                                    onPause={() => {
                                      setcallHistoryIndexFlag(false);
                                    }}
                                  >
                                    <source
                                      src={element.voiceUrl}
                                      type="audio/mpeg"
                                    />
                                  </audio>
                                </td>
                              </tr>
                            </>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>}
        </div>
        {/* Email */}
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class={`accordion-button collapsed ${mainHistoryToggle ? 'rotate-communication':''}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
              onClick={() => {
                getCommentHistory({
                  url: `${config.baseUrl}/Messaging/get-email-messages/${CommentSummry_candidateUniqueId}`,
                  name: "emailHistory",
                  method: 'GET'
                })
                setMainHistoryToggle(!mainHistoryToggle)
              }
              }
            >
              Email History
            </button>
          </h2>
          {mainHistoryToggle &&
            <div
            // id="collapseTwo"
            // class="accordion-collapse collapse"
            // aria-labelledby="headingTwo"
            // data-bs-parent="#accordionExample"
            >
              <div class="accordion-body">
                <div class="table-responsive">
                  <table class="table table-inbox table-hover text-nowrap mb-0">
                    <tbody>
                      {emailHistory?.length > 0 &&
                        emailHistory?.map((element, index) => {
                          const result = (
                            <p
                              dangerouslySetInnerHTML={{
                                __html: element?.messageSubject
                                ,
                              }}
                            ></p>
                          );
                          const val = element?.messageBody
                            ?.split(/\n/)
                            .map((line) => (
                              <React.Fragment key={line}>
                                {line.replace(regex, "")}
                                <br />
                              </React.Fragment>
                            ));
                          return (
                            <>
                              <tr
                              style={element?.fromCandidate ? { backgroundColor: '#FFD300' } : {}}
                                onClick={() => setChildHistoryToggle(index)}
                                className={`collapsed ${element.fromCandidate && ""
                                  }`}
                              // data-bs-toggle="collapse"
                              // data-bs-parent="#accordion"
                              // href={`#data_${index}`}
                              // aria-expanded="false"
                              // aria-controls={`data_${index}`}
                              >
                                <td class="view-message dont-show fw-semibold clickable-row">
                                  {element.messageFrom}
                                </td>
                                <td
                                  class="view-message clickable-row text-truncate"
                                  style={{ maxWidth: "150px" }}
                                >
                                  <ToolTip
                                    position={"bottom"}
                                    value={result}
                                  >
                                    <p>{element.messageSubject}</p>
                                  </ToolTip>
                                </td>
                                <td>
                                  {parseInt(element.sentStatus) ===
                                    0 ? (
                                    <i
                                      class="fa fa-arrow-up"
                                      style={{ color: "orange" }}
                                      title="In Queue"
                                    ></i>
                                  ) : parseInt(element.sentStatus) ===
                                    1 ? (
                                    <i
                                      class="fa fa-check"
                                      style={{ color: "green" }}
                                      title="Success"
                                    ></i>
                                  ) : parseInt(element.sentStatus) ===
                                    2 ? (
                                    <i
                                      class="fa fa-info-circle"
                                      style={{ color: "red" }}
                                      title="Failed"
                                    ></i>
                                  ) : parseInt(element.sentStatus) ===
                                    3 ? (
                                    <i
                                      class="fa fa-exclamation-triangle"
                                      style={{ color: "red" }}
                                      title="Error"
                                    ></i>
                                  ) : (
                                    ""
                                  )}
                                </td>

                                <td>
                                  {element.fromCandidate ? (
                                    <span
                                      onClick={() =>
                                        openReplyModal(
                                          element?.candidateUniqueId,
                                          {
                                            messageTrackingId: element?.messageTrackingId,
                                            messageSubject: element?.messageSubject,
                                            messageBody: element?.messageBody,
                                            messageFrom: element?.messageFrom,
                                            messageTo: element?.messageTo,
                                            messageDate: element?.messageDate,
                                            fromName: element?.messageFromName,
                                            toName: element?.messageToName
                                          }
                                        )
                                      }
                                    >
                                      <i className="fa fa-reply fa-lg" style={{color: '#004D40'}}></i>
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td>
                                  {element?.ticketNo}
                                </td>
                                <td class="view-message text-end fw-semibold clickable-row">
                                  {moment(element.messageDate).format(
                                    "YYYY-MM-DD hh:mm A"
                                  )}
                                </td>
                              </tr>

                              <tr className="bg-white">
                                {childHistoryToggle === index &&
                                  <td
                                  className="text-wrap"
                                    // id={`data_${index}`}
                                    // class="panel-collapse collapse"
                                    // role="tabpanel"
                                    // aria-labelledby={`data_${index}`}
                                    colSpan={6}
                                  >
                                    {/* <>{val}</> */}


                                    <>
                                        <span className='ms-2'>From: {`${element?.messageFromName}<${element?.messageFrom}>`}</span> <br />
                                        <span className='ms-2'>Sent: {moment().format('LLLL')}</span> <br />
                                        <span className='ms-2'>To: {`${element?.messageToName} <${element?.messageTo}>`}</span> <br />
                                        <span className='ms-2'>Subject: {element?.messageSubject}</span><br />
                                    </>

                                    
                                    <div className="mt-3" dangerouslySetInnerHTML={{ __html: element?.messageBody }} ></div>
                                    {element?.messageTrackingAttachments
                                      ?.length > 0
                                      ? element?.messageTrackingAttachments?.map(
                                        (item) => {
                                          return (
                                            <span
                                              rel="noreferrer"
                                              style={{
                                                cursor: "pointer",
                                                color: 'blue',
                                                marginRight:"1rem",
                                                marginBottom:"1rem",
                                                display:"inline-block"
                                              }}
                                              onClick={() =>
                                                downloadUploadDoc(
                                                  item?.attachedFilename,
                                                  item?.messageTrackingAttachmentId,
                                                  {
                                                    url: "Messaging/download-Message-file-tracking-document?MessageTrackingAttachmentId=",
                                                  }
                                                )
                                              }
                                            >
                                              <ImAttachment className="text-primary" />-<i className="text-primary">
                                                {item?.attachedFilename}-<i
                                                className="mdi mdi-arrange-bring-forward text-primary"
                                                data-bs-toggle="tooltip"
                                                title=""
                                                data-bs-original-title="mdi-arrange-bring-forward"
                                                aria-label="mdi-arrange-bring-forward"
                                              ></i>
                                              </i>
                                            </span>
                                          );
                                        }
                                      )
                                      : ""}
                                  </td>}
                              </tr>
                            </>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          }

        </div>


        {/* Text  */}
        <div className="accordion" id="accordionExample">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
              <button
                class={`accordion-button collapsed ${showSmsToggle ? 'rotate-communication':''}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
                onClick={() => {
                  if (!!login?.verifiedPhoneNumber) {
                    console.log({ data, CommentSummry_candidateUniqueId });
                    const params = {
                      candidateUniqueId: userData?.candidateUniqueId,
                      employerMobileNumber: login.verifiedPhoneNumber,
                      candidateMobileNumber: `${login.countryPhoneCode}${(userData?.phone).replace(/-/g, '')}`,
                      isRecentMessageOnTop: true
                    }
                    getCommentHistory({
                      url: `${config.baseUrl}/Messaging/get-sms-messages`,
                      name: "textHistory",
                      params,
                      method: 'POST'
                    })
                    setShowSmsToggle(!showSmsToggle)
                  } else {
                    Toasts.error("SMS faciality not mapped to this employer.")
                  }
                }


                }
              >
                SMS History
              </button>
            </h2>
            {showSmsToggle ?
              <div
              // id="collapseThree"
              // class="accordion-collapse collapse "
              // aria-labelledby="headingThree"
              // data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  <div class="table-responsive">
                    <table class="table table-inbox table-hover text-nowrap mb-0">
                      <tbody>
                        {Array.isArray(textHistory) && textHistory?.map((element, index) => {
                          return (
                            <>
                              <tr
                                class="collapsed"
                                data-bs-toggle="collapse"
                                data-bs-parent="#accordion"
                                href={`#data_${index}`}
                                aria-expanded="false"
                                aria-controls={`data_${index}`}
                              >
                                <td class="view-message dont-show fw-semibold clickable-row">
                                  {element.messageFrom}
                                </td>
                                <td class="view-message clickable-row">
                                  {element.messageBody}
                                </td>
                                <td>
                                  {/* {parseInt(element.sentStatus) === 0 ?
                                    <i class="fa fa-close" style={{ color: "red" }}></i>
                                    :
                                    <i class="fa fa-check" style={{ color: "green" }}></i>
                                  } */}
                                  <span onClick={() => showSmsModal(element)} style={{ cursor: 'pointer', color: '#fff', fontSize: '24px' }} className="text_connection" ><i className="fa fa-commenting-o"></i></span>
                                </td>
                                <td class="view-message text-end fw-semibold clickable-row">
                                  {/* {emailTimeDisplay(
                                                                                            element.messageDate,
                                                                                        )} */}
                                  {element?.messageDateToDisplay}
                                </td>
                              </tr>
                              <div
                                id={`data_${index}`}
                                class="panel-collapse collapse"
                                role="tabpanel"
                                aria-labelledby={`data_${index}`}
                              >
                                <div dangerouslySetInnerHTML={{ __html: element.messageBody }}></div>
                              </div>
                            </>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> : ''

            }
          </div>
        </div>

        {/* Text */}
        {/* <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
              onClick={() =>
                getCommentHistory({
                  url: `${config.baseUrl}/Messaging/get-sms-messages/${CommentSummry_candidateUniqueId}`,
                  name: "textHistory",
                })
              }
            >
              Text History
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <div class="table-responsive">
                <table class="table table-inbox table-hover text-nowrap mb-0">
                  <tbody>
                    {textHistory?.length > 0 &&
                      textHistory.map((element, index) => {
                        return (
                          <>
                            <tr
                              class="collapsed"
                              data-bs-toggle="collapse"
                              data-bs-parent="#accordion"
                              href={`#data_${index}`}
                              aria-expanded="false"
                              aria-controls={`data_${index}`}
                            >
                              <td class="view-message dont-show fw-semibold clickable-row">
                                {element.messageFrom}
                              </td>
                              <td class="view-message clickable-row">
                                {element.messageBody}
                              </td>
                              <td>
                                {parseInt(element.sentStatus) === 0 ? (
                                  <i
                                    class="fa fa-close"
                                    style={{ color: "red" }}
                                  ></i>
                                ) : (
                                  <i
                                    class="fa fa-check"
                                    style={{ color: "green" }}
                                  ></i>
                                )}
                              </td>
                              <td class="view-message text-end fw-semibold clickable-row">
                                {moment(element.messageDate).format(
                                  "YYYY-MM-DD HH:mm A"
                                )}
                              </td>
                            </tr>
                            <div
                              id={`data_${index}`}
                              class="panel-collapse collapse"
                              role="tabpanel"
                              aria-labelledby={`data_${index}`}
                            >
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: element.messageBody,
                                }}
                              ></div>
                            </div>
                          </>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};
